import {
    CLEAR_FILTER,
    PARENT_FILTERS_CHANGED, RESET_ALL_FILTERS,
    SET_SELECTED_URL_FILTERS, STOP_AIRPORT_SELECTED,
    STOP_AIRPORTS_BATCH_RECEIVED, STOP_AIRPORTS_FILTER_SHOW_MORE
} from "../../actions/FlightsActions";

const initialState = {
    airports: {},
    selected: [],
    page: 1
};

const StopAirportsFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case STOP_AIRPORTS_BATCH_RECEIVED:
            return {
                ...state, airports: action.payload
            };
        case STOP_AIRPORT_SELECTED:
            if (state.selected.indexOf(action.airport) === -1) {
                return {
                    ...state, selected: [...state.selected, action.airport]
                };
            }

            return {
                ...state, selected: state.selected.filter(item => item !== action.airport)
            };
        case SET_SELECTED_URL_FILTERS:
            if (action.name === 'stopAirports') {
                return {
                    ...state,
                    selected: action.payload,
                };
            }

            return state;
        case PARENT_FILTERS_CHANGED:
            return {
                ...state,
                selected: action.filters.stopAirports,
            };
        case STOP_AIRPORTS_FILTER_SHOW_MORE:
            return {...state, page: ++state.page};
        case CLEAR_FILTER:
            if (action.filter === 'stopAirports') {
                return {...state, selected: initialState.selected};
            }

            return state;
        case RESET_ALL_FILTERS:
            return {...state, selected: initialState.selected};
        default:
            return state
    }
};

export default StopAirportsFilterReducer;



// WEBPACK FOOTER //
// ./src/reducers/filters/StopAirportsFilterReducer.js